/**
 * Advisor Primary Goals - Standardized goals for mySuccession platform usage
 * Used during profile completion and saved to team_members.primary_goals
 */
export const ADVISOR_PRIMARY_GOALS = [
  "Plan my business exit",
  "Understand my business value",
  "Optimize my practice for sale",
  "Find a successor",
  "Transition my book of business",
  "Partnership succession planning",
  "Build a continuity plan",
  "Mentor next generation",
  "Exploring options",
  "Other",
] as const;

export type AdvisorPrimaryGoal = typeof ADVISOR_PRIMARY_GOALS[number];
